import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  DxFormModule,
  DxSelectBoxModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ProjectData, DepartmentRole } from '../../project-creation-form.component';
import { HolderSelectComponent } from 'src/app/components/holder-select/holder-select.component';

@Component({
    selector: 'app-project-roles-step',
    imports: [
        CommonModule,
        DxFormModule,
        DxSelectBoxModule,
        DxValidatorModule,
        HolderSelectComponent
    ],
    templateUrl: './project-roles-step.component.html',
    styleUrl: './project-roles-step.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectRolesStepComponent {
  @Input() projectData: ProjectData;
  @Input() departments: any[] = [];
  @Input() users: any[] = [];
  @Input() validationGroup: string;



  @Output() projectDataChange = new EventEmitter<ProjectData>();

  constructor(private cdr: ChangeDetectorRef) {}
}